var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Selector, State, Store } from '@ngxs/store';
import { ShareableLinksApiService } from './shareable-links-api.service';
import { finalize, tap } from 'rxjs/operators';
import { DriveState } from '../../state/drive-state';
import { Settings } from 'common/core/config/settings.service';
var LoadShareableLink = /** @class */ (function () {
    function LoadShareableLink(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
    }
    LoadShareableLink.type = '[Shareable Link] Load From Backend';
    return LoadShareableLink;
}());
export { LoadShareableLink };
var UpdateShareableLink = /** @class */ (function () {
    function UpdateShareableLink(options) {
        this.options = options;
    }
    UpdateShareableLink.type = '[Shareable Link] Update';
    return UpdateShareableLink;
}());
export { UpdateShareableLink };
var CreateShareableLink = /** @class */ (function () {
    function CreateShareableLink(options) {
        this.options = options;
    }
    CreateShareableLink.type = '[Shareable Link] Create';
    return CreateShareableLink;
}());
export { CreateShareableLink };
var DeleteShareableLink = /** @class */ (function () {
    function DeleteShareableLink() {
    }
    DeleteShareableLink.type = '[Shareable Link] Delete';
    return DeleteShareableLink;
}());
export { DeleteShareableLink };
var ToggleOptionsPanel = /** @class */ (function () {
    function ToggleOptionsPanel() {
    }
    ToggleOptionsPanel.type = '[Shareable Link] Toggle Options Panel Visibility';
    return ToggleOptionsPanel;
}());
export { ToggleOptionsPanel };
var LinkCopySuccess = /** @class */ (function () {
    function LinkCopySuccess() {
    }
    LinkCopySuccess.type = '[Shareable Link] Copy To Clipboard Success';
    return LinkCopySuccess;
}());
export { LinkCopySuccess };
var ResetShareLinkState = /** @class */ (function () {
    function ResetShareLinkState() {
    }
    ResetShareLinkState.type = '[Shareable Link] Reset State';
    return ResetShareLinkState;
}());
export { ResetShareLinkState };
var defaultState = {
    link: null,
    loading: false,
    optionsPanelVisible: true,
    backendErrors: {},
    cache: {},
    linkOptions: {
        allowDownload: false,
        allowEdit: false,
        expiresAt: null,
        password: null,
    }
};
var ShareLinkState = /** @class */ (function () {
    function ShareLinkState(store, settings, linksApi) {
        this.store = store;
        this.settings = settings;
        this.linksApi = linksApi;
    }
    ShareLinkState.loading = function (state) {
        return state.loading;
    };
    ShareLinkState.link = function (state) {
        return state.link;
    };
    ShareLinkState.optionsVisible = function (state) {
        return !state.loading && state.optionsPanelVisible;
    };
    ShareLinkState.backendErrors = function (state) {
        return state.backendErrors;
    };
    ShareLinkState.prototype.createShareableLink = function (ctx, action) {
        var entryId = this.store.selectSnapshot(DriveState.selectedEntryIds)[0];
        ctx.patchState({ loading: true });
        return this.linksApi.create(entryId, action.options)
            .pipe(finalize(function () { return ctx.patchState({ loading: false, backendErrors: {} }); }), tap(function (response) {
            var _a;
            var link = response.link;
            ctx.patchState({
                cache: __assign({}, ctx.getState().cache, (_a = {}, _a[link.entry_id] = link, _a)),
                link: response.link,
                optionsPanelVisible: false
            });
        }, function (errorResponse) {
            ctx.patchState({ backendErrors: errorResponse.messages });
        }));
    };
    ShareLinkState.prototype.updateLink = function (ctx, action) {
        var link = ctx.getState().link;
        ctx.patchState({ loading: true });
        return this.linksApi.update(link.id, action.options)
            .pipe(finalize(function () { return ctx.patchState({ loading: false, backendErrors: {} }); }), tap(function (response) {
            var _a;
            return ctx.patchState({
                link: response.link,
                cache: __assign({}, ctx.getState().cache, (_a = {}, _a[link.entry_id] = response.link, _a)),
                optionsPanelVisible: false
            });
        }, function (errorResponse) {
            ctx.patchState({ backendErrors: errorResponse.messages });
        }));
    };
    ShareLinkState.prototype.loadShareableLink = function (ctx, action) {
        var entryId = this.store.selectSnapshot(DriveState.selectedEntryIds)[0], cachedLink = ctx.getState().cache[entryId];
        if (cachedLink) {
            return ctx.patchState({ link: cachedLink, optionsPanelVisible: false });
        }
        ctx.patchState({ loading: true });
        return this.linksApi.findByEntryId(entryId, { autoCreate: action.options.autoCreate })
            .pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) {
            var _a;
            return ctx.patchState({
                link: response.link,
                optionsPanelVisible: false,
                cache: __assign({}, ctx.getState().cache, (_a = {}, _a[response.link.entry_id] = response.link, _a)),
            });
        }, function () { }));
    };
    ShareLinkState.prototype.deleteShareableLink = function (ctx) {
        var link = ctx.getState().link;
        ctx.patchState({ loading: true });
        return this.linksApi.delete(link.id)
            .pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function () {
            var cache = ctx.getState().cache;
            delete cache[link.entry_id];
            ctx.patchState({
                link: null,
                cache: cache,
            });
        }));
    };
    ShareLinkState.prototype.toggleOptionsPanel = function (ctx) {
        ctx.patchState({
            optionsPanelVisible: !ctx.getState().optionsPanelVisible
        });
    };
    ShareLinkState.prototype.resetShareLinkState = function (ctx) {
        return ctx.patchState(__assign({}, ctx.getState(), defaultState));
    };
    __decorate([
        Action(CreateShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "createShareableLink", null);
    __decorate([
        Action(UpdateShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "updateLink", null);
    __decorate([
        Action(LoadShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "loadShareableLink", null);
    __decorate([
        Action(DeleteShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "deleteShareableLink", null);
    __decorate([
        Action(ToggleOptionsPanel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "toggleOptionsPanel", null);
    __decorate([
        Action(ResetShareLinkState, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "resetShareLinkState", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "loading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "link", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "optionsVisible", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "backendErrors", null);
    ShareLinkState = __decorate([
        State({
            name: 'shareLink',
            defaults: defaultState
        }),
        __metadata("design:paramtypes", [Store,
            Settings,
            ShareableLinksApiService])
    ], ShareLinkState);
    return ShareLinkState;
}());
export { ShareLinkState };
